export default __webpack_public_path__ + "static/media/dashboard-crypto.acff72f8.jpg";